import { Injector } from '@angular/core';
import { TECH_CHART_APP_STATE_SLICE_KEY, TECH_CHART_STATE_KEYS } from 'ChartApp/ts/features/tech-chart/constants';
import { AppStateService } from 'Angular/services/app-state.service';
import { AppStateManager } from 'Angular/services/app-state-manager.service';
import { TechChartUrlDeserializer } from 'ChartApp/ts/features/tech-chart-page-shared/state/tech-chart.deserializer';
import { TechChartUrlSerializer } from 'ChartApp/ts/features/tech-chart-page-shared/state/tech-chart.serializer';
import * as i0 from "@angular/core";
export class TechChartAppStateManager extends AppStateManager {
    // AppStateService is lazily resolved to avoid a circular dependency: this service is
    // providedIn: 'root' and AppStateService depends on ActivatedRoute, which isn't available
    // on pages without a Router.
    constructor(injector) {
        super(null);
        this.injector = injector;
    }
    resolveAppStateService() {
        if (this.appStateService === null) {
            this.appStateService = this.injector.get(AppStateService, null);
        }
    }
    initAppState() {
        this.resolveAppStateService();
        if (!this.appStateService)
            return;
        this.appStateService.setStateSlice(TECH_CHART_APP_STATE_SLICE_KEY);
        this.appStateService.setUrlParamKeys(TECH_CHART_STATE_KEYS);
        this.appStateService.setCustomUrlParamDeserializer(TechChartUrlDeserializer);
        this.appStateService.setCustomUrlParamSerializer(TechChartUrlSerializer);
        this.appStateService.start();
    }
    resetToSystemDefault() {
        this.resolveAppStateService();
        if (this.appStateService) {
            this.appStateService.resetToSystemDefaultState();
        }
    }
}
TechChartAppStateManager.ɵfac = function TechChartAppStateManager_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || TechChartAppStateManager)(i0.ɵɵinject(i0.Injector)); };
TechChartAppStateManager.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: TechChartAppStateManager, factory: TechChartAppStateManager.ɵfac, providedIn: 'root' });
